import { TableHeadItemRecurse } from '../../../../../components/TableHead';

export const tableHead: TableHeadItemRecurse[] = [
  { title: 'Ativo', flex: 2 },
  { title: 'Categoria', flex: 1.2 },
  { title: 'Tipo' },
  { title: 'Qtd. disponível' },
  { title: 'Qtd. bloqueada' },
  { title: 'Qtd. total' },
  { title: 'Preço médio', flex: 1.5 },
  { title: 'Preço atual', flex: 1.5 },
  { title: 'Resultado', flex: 1.5 },
  { title: 'Variação', flex: 1.5 },
  { title: 'Valor', flex: 1.8 },
];
